var _defs, _path, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLogo11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.53,43.19v-14.33h-41.82v61.28h16.71v-46.95h25.11Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.05 55.52 46.98 65.44 36.83 75.59 37.05 55.52"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "85.52 56.88 85.49 59.87 104.17 59.87 104.17 71.19 87.46 71.19 87.46 112.14 73.75 112.14 73.89 71.36 72.25 73 70.85 74.4 70.74 115.14 90.46 115.14 90.46 74.19 107.17 74.19 107.17 56.87 85.52 56.88"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "82.19 56.87 68.49 56.87 82.38 70.79 82.52 56.88 82.38 56.88 82.19 56.87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo11);
export default __webpack_public_path__ + "static/media/whiteLogo11.a095665e9ec203c6c85c6888cccca807.svg";
export { ForwardRef as ReactComponent };